import GLightbox from "../../assets/vendor/glightbox/dist/js/glightbox";

Vue.asyncComponent('ak-video', {
    name:'ak-video',
    props: {
        src: {
            type: String,
            required: true
        },
        width: {
            type: String,
        },
        height: {
            type: String,
        },
        showControls: {
            type: Boolean,
            default: true
        },
        muted: {
            type: Boolean,
        },
        loop: {
            type: Boolean,
        },
        autoplay: {
            type: Boolean,
        },
        enableLightbox: {
            type: Boolean,
        },
        galleryId: {
            type: String,
        },
    },
    computed: {
        /**
         * Light gallery class
         * @return {string}
         */
        lightGalleryClass() {
            return 'lightgallery-' + (this.galleryId ? this.galleryId : this._uid);
        },
    },
    mounted() {
        if (this.enableLightbox) {
            new GLightbox({
                selector: '.' + this.lightGalleryClass,
                touchNavigation: true,
            });
        }
    },
}, 'layout/ak-video.html');